import Vue from 'vue';
import { Module } from 'vuex';

import { RootState } from 'frontend/types';

import { postData } from 'frontend/utils/ajax';
import { stringifyQueryParams } from 'frontend/utils/urls';

interface PlanFiltersState {
  items: any[];
}

const planFilters: Module<PlanFiltersState, RootState> = {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    planFilterDataByCountry(state) {
      return state.items;
    },
  },
  mutations: {
    setValue(state: PlanFiltersState, value: any[]): void {
      Vue.set(state, 'items', value);
    },
    reloadItems(state, newItems: any) {
      Vue.set(state, 'items', newItems);
    },
  },
  actions: {
    async saveChanges({ commit }, data: any) {
      let response;
      try {
        response = await postData('/payment_processor/admin/update-plan-filters/', data);
      } catch (e) {
        return false;
      }

      if (response?.results?.plan_filters) {
        commit('planFilters/reloadItems', response.results.plan_filters, { root: true });
        return true;
      }
      return false;
    },
  },
};

export default planFilters;
